import React from "react";
import PropTypes from "prop-types";
import { NavLink } from "react-router-dom";

export default function Navbar(props) {
  return (
    <nav
      className={`navbar navbar-expand-lg navbar-${props.mode} bg-${props.mode}`}
    >
      <div className="container-fluid">
        <NavLink className="navbar-brand" to="/">
          {props.title}
        </NavLink>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <ul className="navbar-nav me-auto mb-2 mb-lg-0">
            <li className="nav-item">
              <NavLink className="nav-link" aria-current="page" to="/">
                Home
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink className="nav-link" to="/about">
                About
              </NavLink>
            </li>
          </ul>
          <div
            className="d-flex justify-content-between"
            style={{
              marginRight: "10px",
              width: "70px",
              paddingBottom: "12px",
              paddingTop: "7px",
            }}
          >
            <div
              onClick={props.themeg}
              className="themeg"
              style={{
                backgroundColor: "green",
                width: "27px",
                height: "27px",
                borderRadius: "5px",
                border: `1px solid ${props.mode==="light"?"black":""}`,
                cursor: "pointer",
              }}
            ></div>
            <div
              onClick={props.themer}
              className="themer"
              style={{
                backgroundColor: "crimson",
                width: "27px",
                height: "27px",
                borderRadius: "5px",
                border: `1px solid ${props.mode==="light"?"black":""}`,
                cursor: "pointer",
              }}
            ></div>
          </div>

          <div
            className={`form-check form-switch text-${
              props.mode === "light" ? "dark" : "light"
            }`}
          >
            <input
              className="form-check-input"
              type="checkbox"
              id="darkModeSwitch"
              onClick={props.toggleMode}
            />
            <label
              className="form-check-label"
              htmlFor="flexSwitchCheckDefault"
            >
              Dark Mode
            </label>
          </div>
        </div>
      </div>
    </nav>
  );
}

Navbar.propTypes = {
  title: PropTypes.string.isRequired,
};
Navbar.defaultProps = {
  title: "Set Title Here",
};
